import React from 'react';

import TitleAndDescriptionWithOrder from '@components/nycLanding/_shared/titleAndDescriptionWithOrder';
import { NYCLandingType } from '@utils/types/landings';

import styles from './styles.module.scss';

type Props = {
  order: number;
} & NYCLandingType['howItWorks'];

const HowItWorks = (props: Props) => {
  const { title, description, items, order } = props;

  return (
    <div className={styles.howItWorks}>
      <div className={styles.howItWorks__wrapper}>
        <TitleAndDescriptionWithOrder
          title={title}
          description={description}
          order={order}
        />

        <div className={styles.howItWorks__items}>
          {items?.map((i, key) => (
            <div className={styles.item} key={i._key}>
              <div className={styles.item__title}>{`${key + 1}. ${
                i.title
              }`}</div>
              <div className={styles.item__description}>{i.description}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
